<template>
    <div v-html="svgContent"></div>
</template>

<script>
export default {
    props: {
        svgContent: {
            type: String,
            required: true
        }
    }
};
</script>
